<mat-list class="management-list">
  @for (item of (items$ | async); track item; let i = $index) {
    <mat-list-item
      [ngClass]="{'selected-bold': (item.tag && item.tag === selectedItem?.tag) || (item.id && item.id === selectedItem?.id)}"
      [contextMenu]="basicMenu" [contextMenuValue]="item"
      >
      <button
        [attr.data-testid]="item.name + '_option'"
        mat-button
        (click)="onItemSelected(item)"
        >
        <span class="bull">&#8226;</span>
        <span class="align-text" [ngClass]="{'item-disabled': item.disabled}">
          {{ item.name }} @if (item?.tag && (showTags$ | async)) {
          <span [ngStyle]="{ fontSize: '13px' }">- {{ item?.tag }}</span>
        }
      </span>
    </button>
    <context-menu #basicMenu [disabled]="isReadOnly || isMmsAuthorOnly">
      @for (action of contextMenuActions; track action) {
        <ng-template
          contextMenuItem let-item
          [visible]="!isMmsAuthorOnly && (action.visible ? action.visible(item.source) : true)"
          [disabled]="((action.enabled && !action.enabled(item.source)) || disableContextActions || isMmsAuthorOnly)"
          [divider]="action.divider" (execute)="action.click && action.click(item.source)"
          >
          <span
            [attr.data-testid]="action.text && action.text(item.source) + '_button'"
          >{{ action.text && action.text(item.source) }}</span>
          <mat-icon
            [attr.data-testid]="action.text(item.source) + '_icon'"
          >{{ action.icon && action.icon(item.source) }}</mat-icon>
        </ng-template>
      }
    </context-menu>
  </mat-list-item>
}
</mat-list>
